// Package Imports
/* eslint-disable max-lines */
import React, { useEffect, useState } from 'react';
import { useSimpleList, useTable } from '@refinedev/antd';
import { Card, Row, Col, Statistic, Select } from 'antd';
import PivotTableUI from 'react-pivottable/PivotTableUI';
import 'react-pivottable/pivottable.css';
import TableRenderers from 'react-pivottable/TableRenderers';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';
import Plot from 'react-plotly.js';

// Project Imports
import apiEndpoint from 'core/common/apiEndPoints';
import Loading from 'components/loading/loading';
import { BaseRecord, useTranslate } from '@refinedev/core';

const CalSummary = () => {
  const { pathname } = window.location;
  const [, , , paymentProcessId, id] = pathname.split('/');
  const [pivotData, setPivotData] = useState([]);
  const [summaryStats, setSummaryStats] = useState({
    totalPayout: 0,
    agencyCount: 0,
    userCount: 0,
  });
  const [selectedPlanId, setSelectedPlanId] = useState('');
  const [pivotState, setPivotState] = useState({
    aggregatorName: 'Sum',
    rendererName: 'Table',
    rows: [],
    cols: [],
    vals: [],
  });
  const [isDataReady, setIsDataReady] = useState(false);
  const t = useTranslate();

  const excludedFields = [
    'applicableGrids',
    'calculation_details_id',
    'composite_key_order',
    'composite_key',
    'decisionOutputs',
    'final_output_formula',
    'frequency',
    'frequency_id',
    'iprogram_id',
    'organization_id',
    'payment_process_id',
    'rowsCount',
    'secondayApplicableGrids',
    'serial',
    'total_collected_amount_name',
    'unified_id',
    'workflow_status_id',
    'payprompt_id',
    'a8_batch_id',
    'a8_created_at',
    'a8_transaction_datetime',
    'agencyCount',
    'agencySerial',
    'User',
  ];

  const { listProps: rulePlanTableProps } = useSimpleList({
    resource: `${apiEndpoint.getPaymentProcessDetails}/?payment_process_id=${paymentProcessId}`,
    dataProviderName: 'payoutProvider',
    pagination: { mode: 'off' },
    syncWithLocation: false,
    queryOptions: {
      enabled: !!paymentProcessId,
    },
  });
  const rulePlanData =
    (rulePlanTableProps?.dataSource as BaseRecord)?.results || [];

  const dropdownOptions = (rulePlanData || []).map((item) => ({
    calculation_details_id: item.calculation_detail_id,
    final_output_variable_name: item.final_output_variable_name,
    tab_title: item.rule_plan_name,
    rule_plan_compensation_type: item.rule_plan_compensation_type,
  }));

  const isDropdownLoading = rulePlanTableProps?.loading;
  // const condition = dropdownOptions.length > 0 && !!selectedPlanId && selectedPlanId !== '';
  // const condition = isDropdownLoading? false :dropdownOptions.length > 0 ? !! selectedPlanId : !!id;

  let condition = false;
  if (!isDropdownLoading) {
    if (dropdownOptions.length > 0) {
      condition = !!selectedPlanId;
    } else {
      condition = !!id;
    }
  }
  const { tableProps: taskDetailsListProps, tableQueryResult } = useTable({
    resource: `${apiEndpoint.getAllRecordById}/?id=${selectedPlanId || id}&orderBy=${selectedPlanId ? dropdownOptions.find((opt) => opt.calculation_details_id === selectedPlanId)?.final_output_variable_name : 'Final Payout'}`,
    dataProviderName: 'payoutProvider',
    pagination: { mode: 'server' },
    syncWithLocation: false,
    onSearch: (value) => [{ field: 'search', operator: 'eq', value }],
    queryOptions: {
      enabled: condition,
    },
  });

  const taskDetails = taskDetailsListProps?.dataSource || [];

  const { tableProps: taskSummaryListProps } = useTable({
    resource: `${apiEndpoint.getAllRecordById}/?id=${paymentProcessId}&orderBy=Final Payout`,
    dataProviderName: 'payoutProvider',
    pagination: { mode: 'server' },
    syncWithLocation: false,
    onSearch: (value) => [{ field: 'search', operator: 'eq', value }],
  });
  // Set initial selection
  useEffect(() => {
    if (dropdownOptions.length > 0 && !selectedPlanId) {
      setSelectedPlanId(dropdownOptions[0].calculation_details_id);
    }
  }, [dropdownOptions]);

  const summaryDetails = taskSummaryListProps?.dataSource || [];
  console.log(summaryDetails, 'summaryDetails');

  const isNumericField = (value) => {
    console.log(value);
    return value !== null && value !== undefined && parseFloat(value) && value;
  };

  const findFinalPayoutField = (data) => {
    if (!data?.length) return null;
    const sampleRow = data[0];

    // Find selected plan's payout field name
    const selectedOption = dropdownOptions.find(
      (opt) => opt.calculation_details_id === selectedPlanId
    );
    const payoutFieldName =
      selectedOption?.final_output_variable_name || 'Final Payout';

    // Use the dynamic field name
    const possibleNames = [payoutFieldName];

    const matchingField = possibleNames.find(
      (name) =>
        Object.prototype.hasOwnProperty.call(sampleRow, name) &&
        isNumericField(sampleRow[name])
    );

    if (matchingField) return matchingField;

    const fallback = Object.keys(sampleRow).find(
      (key) =>
        key.toLowerCase().includes('payout') &&
        !excludedFields.includes(key) &&
        isNumericField(sampleRow[key])
    );

    return (
      fallback ||
      Object.keys(sampleRow).find(
        (key) => !excludedFields.includes(key) && isNumericField(sampleRow[key])
      )
    );
  };

  useEffect(() => {
    if (taskDetails?.length) {
      try {
        const transformed = taskDetails.map((item, idx) => {
          const val = '_source';
          const source = item[val] || item;
          const out = { id: idx };

          Object.keys(source).forEach((key) => {
            if (
              excludedFields.includes(key) ||
              source[key] == null ||
              Array.isArray(source[key]) ||
              (typeof source[key] === 'object' &&
                !(source[key] instanceof Date))
            ) {
              return;
            }

            if (
              typeof source[key] === 'string' &&
              /^\d{4}-\d{2}-\d{2}T/.test(source[key])
            ) {
              const d = new Date(source[key]);
              out[key] = d.getTime() ? source[key] : d.toLocaleDateString();
            } else if (isNumericField(source[key])) {
              out[key] = parseFloat(source[key]);
            } else {
              out[key] = String(source[key]);
            }
          });
          return out;
        });

        setPivotData(transformed);

        const defaultVal = findFinalPayoutField(transformed);
        if (defaultVal) {
          setPivotState((prev) => ({
            ...prev,
            vals: [defaultVal],
            rendererName: 'Bar Chart',
          }));
        }

        setIsDataReady(true);
      } catch (e) {
        console.error('Pivot transform error:', e);
      }
    }
  }, [taskDetails]);

  useEffect(() => {
    if (summaryDetails?.length > 0 && taskDetails?.length > 0) {
      const val = '_source';
      const stats = {
        totalPayout: 0,
        agencyCount: 0,
        userCount: 0,
      };
      if (taskDetails?.length > 0) {
        let totalPayout = 0;
        taskDetails.forEach((item) => {
          const sourcee = item[val] || item;
          // Use dynamic payout field based on selected plan
          const selectedOption = dropdownOptions.find(
            (opt) => opt.calculation_details_id === selectedPlanId
          );
          const payoutFieldName =
            selectedOption?.final_output_variable_name || 'Final Payout';
          if (
            sourcee[payoutFieldName] &&
            isNumericField(sourcee[payoutFieldName])
          ) {
            totalPayout += parseFloat(sourcee[payoutFieldName]);
          }
        });
        stats.agencyCount = summaryDetails?.length;
        stats.userCount = taskDetails?.length;
        stats.totalPayout = totalPayout;
      }
      setSummaryStats(stats);
    }
  }, [summaryDetails, taskDetails, selectedPlanId]);

  const cleanPivotState = (state) => {
    const { rows, cols, vals } = state;
    const unique = (arr) => Array.from(new Set(arr));
    const removeDupes = (source, ...others) =>
      source.filter((item) => !others.flat().includes(item));
    return {
      ...state,
      rows: unique(removeDupes(rows, cols, vals)),
      cols: unique(removeDupes(cols, rows, vals)),
      vals: unique(removeDupes(vals, rows, cols)),
    };
  };

  const handlePivotChange = (newState) => {
    setPivotState(cleanPivotState(newState));
  };

  //   onchange= {(value)}= >{
  // setSelectedPlanId(value);
  // setIsDataReady(false),
  // setPivotData([]);
  //   }

  const plotlyRenderers = createPlotlyRenderers(Plot);

  const renderSummaryCards = () => (
    <Row gutter={[24, 0]} style={{ marginBottom: '16px' }}>
      <Col span={8}>
        <Card className="bg-primary-100">
          <Statistic
            title="Number of Agencies"
            value={summaryStats.agencyCount}
          />
        </Card>
      </Col>
      <Col span={8}>
        <Card className="bg-primary-100">
          <Statistic title="Number of Users" value={summaryStats.userCount} />
        </Card>
      </Col>
      <Col span={8}>
        <Card className="bg-primary-100">
          <Statistic
            title="Total Payout"
            value={summaryStats.totalPayout}
            precision={2}
            prefix="₹"
          />
        </Card>
      </Col>
    </Row>
  );

  const renderContent = () => {
    if (isDataReady && pivotData.length > 0) {
      const hasMultiplePlans = dropdownOptions.length > 1;
      return (
        <>
          {renderSummaryCards()}
          {hasMultiplePlans ? (
            <div
              style={{
                marginBottom: '16px',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Select
                style={{ width: 300 }}
                placeholder="Select Rule Plan"
                value={selectedPlanId}
                onChange={(value) => setSelectedPlanId(value)}
                options={dropdownOptions.map((opt) => ({
                  label: opt.tab_title,
                  value: opt.calculation_details_id,
                }))}
              />
            </div>
          ) : null}
          <PivotTableUI
            data={pivotData}
            onChange={handlePivotChange}
            renderers={{ ...TableRenderers, ...plotlyRenderers }}
            hiddenAttributes={excludedFields}
            hiddenFromAggregators={excludedFields}
            hiddenFromDragDrop={excludedFields}
            {...pivotState}
          />
        </>
      );
    }

    return (
      <div
        style={{
          textAlign: 'center',
          padding: '40px',
          color: 'var(--neutral-300)',
        }}
      >
        {t('common.calSummarydesc')}
      </div>
    );
  };

  return (
    <Card
      title={t('common.payoutAnalysis')}
      style={{ margin: '16px', minHeight: 'calc(100vh - 32px)' }}
    >
      {taskDetailsListProps?.loading ||
      tableQueryResult.isLoading ||
      tableQueryResult.isFetching ? (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1000,
          }}
        >
          <Loading />
        </div>
      ) : (
        <div style={{ position: 'relative', overflow: 'auto', padding: '8px' }}>
          {renderContent()}
        </div>
      )}
    </Card>
  );
};

export default CalSummary;
